module.exports = __webpack_public_path__ + "static/media/logo.b3ab85b6.png";